//import data from "../../gitInfo.json";

let info = {};

// if (data.branchName.includes("Produccion") == true) {
//if(true){
info = {
  domainName: window.location.hostname == "localhost" ? "" : "/PrusiaPlus",
  domainNameWithHttp:
    window.location.hostname == "localhost"
      ? "http://localhost:60316/"
      : "https://www.ausa.com.mx/PrusiaPlus/",
  domainNameForApi:
    window.location.hostname == "localhost"
      ? "http://localhost:60316/api/"
      : "https://www.ausa.com.mx/PrusiaPlus/api/",
  domainAusa:
    window.location.hostname == "localhost"
      ? "http://localhost:1908"
      : "https://www.ausa.com.mx/PrusiaPlus",
  domainNameDev: "https://www.ausa.com.mx/",

  nameCookiePGV2: "PrusiaGoV2", //"PruebonPGV2",
  nameLocalStoragePGV2: "PrusiaPlus",
  nameLocalStorageFinanzas: "afusername",
};
// } else {
//   info = {
//     domainName:
//       window.location.hostname == "localhost" ? "" : "/pruebon/PrusiaPlus",
//     domainNameWithHttp:
//       window.location.hostname == "localhost"
//         ? "http://localhost:60316/"
//         : "https://www.ausa.com.mx/pruebon/PrusiaPlus/",
//     domainNameForApi:
//       window.location.hostname == "localhost"
//         ? "http://localhost:60316/api/"
//         : "https://www.ausa.com.mx/pruebon/PrusiaPlus/api/",
//     domainAusa:
//       window.location.hostname == "localhost"
//         ? "http://localhost:1902"
//         : "https://www.ausa.com.mx/pruebon/PrusiaGo",
//     domainNameDev: "https://www.ausa.com.mx/pruebon/",

//     nameCookiePGV2: "PruebonPlus", //"PruebonPGV2",
//     nameLocalStoragePGV2: "PruebonPrusiaPlus",
//     nameLocalStorageFinanzas: "afusername",
//   };
// }

export default info;
